import React, { Suspense, lazy } from "react"

// Lazy load navigation components
const Header = lazy(() => import("../components/header"))
const Nav = lazy(() => import("../components/nav"))
const Footer = lazy(() => import("../components/footer"))

// Skeleton components for navigation
const HeaderSkeleton = () => (
  <header className="bg-white dark:bg-gray-800 shadow-sm animate-pulse">
    <div className="container mx-auto px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
        <div className="flex items-center space-x-4">
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
          <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-20"></div>
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
        </div>
      </div>
    </div>
  </header>
)

const NavSkeleton = () => (
  <nav className="hidden md:block border-t border-b sticky top-0 z-10 bg-white border-gray-200 animate-pulse">
    <div className="container mx-auto px-4">
      <div className="flex justify-between items-center h-12">
        <div className="flex items-center flex-grow space-x-8">
          {/* Generic navigation placeholders - no specific content until API loads */}
          {[...Array(8)].map((_, i) => (
            <div key={i} className="h-4 bg-gray-200 rounded" style={{ width: `${Math.random() * 40 + 40}px` }}></div>
          ))}
          <div className="flex items-center space-x-1">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
            <div className="h-3 w-3 bg-gray-200 rounded"></div>
          </div>
        </div>
        {/* Right section: Search and user */}
        <div className="flex items-center space-x-6">
          <div className="h-6 bg-gray-200 rounded-full w-32"></div>
          <div className="h-4 bg-gray-200 rounded w-16"></div>
        </div>
      </div>
    </div>
  </nav>
)

const FooterSkeleton = () => (
  <footer className="bg-gray-800 text-white animate-pulse">
    <div className="container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="space-y-4">
            <div className="h-5 bg-gray-700 rounded w-3/4"></div>
            <div className="space-y-2">
              {[...Array(4)].map((_, j) => (
                <div key={j} className="h-4 bg-gray-700 rounded w-full"></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </footer>
)

const DefaultLayout = ({ children }) => {
  return (
    <>
      <Suspense fallback={<HeaderSkeleton />}>
        <Header />
      </Suspense>
      <Suspense fallback={<NavSkeleton />}>
        <Nav />
      </Suspense>
      <main>{children}</main>
      <Suspense fallback={<FooterSkeleton />}>
        <Footer />
      </Suspense>
    </>
  )
}

export default DefaultLayout
